<!-- <div class="main-background">
  <div class="container" id="container">

    <div class="form-container sign-up-container">

      <form action="#">

        <h1 style="color: #FD5924;">Create One</h1>

        <span></span>
        <input style="border-radius: 10px;" type="text" placeholder="Name" />
        <input style="border-radius: 10px;" type="email" placeholder="Email" />
        <input style="border-radius: 10px;" type="tel" placeholder="Mobile Number" />
        <input style="border-radius: 10px;" type="password" placeholder="Password" />
        <button>Continue</button>
      </form>
    </div>
    <div class="form-container sign-in-container">
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <h1 style="color: #FD5924;">Login to your account</h1>
        <div>
          <input style="border-radius: 10px;" type="text" placeholder="Username" formControlName="username" />
          <div *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched" style="color:red;">
            Username is required
          </div>
        </div>
        <div>
          <input style="border-radius: 10px;" type="password" placeholder="Password" formControlName="password" />
          <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" style="color:red;">
            Password is required
          </div>
        </div>
        <div class="link-row">
          <a style="color: #FD5924;" href="#">Forgot your password?</a>
          <a style="color: #FD5924;" href="#">Login as guest</a>
        </div>
        <button type="submit" [disabled]="loginForm.invalid">Log In</button>
      </form>
    </div>
    <div class="overlay-container">
      <div class="overlay">
        <div class="overlay-panel overlay-left">

          <h1>Welcome Back!</h1>
          <p>To keep connected with us please login with your personal info</p>
          <button class="ghost" id="signIn">Log In</button>
        </div>
        <div class="overlay-panel overlay-right">
          <h1>Hello!</h1>
          <p>Enter your personal details and start journey with us</p>
          <button class="ghost" id="signUp">CreateOne</button>
        </div>
      </div>
    </div>
  </div>
</div> -->


<div class=" main_Hero1">
  <div class=" Hero">
    <div class=" Hero">
      <div class="container">
        <div class="heroContent">
          <div class=" hero-logo">
            <img src="../../assets/images/Logo.svg" alt="Nishwik Logo">
          </div>
          <!-- <div class="main-content">
                        <h6>INDIA’S FIRST HYBRID</h6>
                        <h2>Finance, Property, Freedom<br>
                            Together.</h2>
                        <p>Get home loans, school EMIs, instant credit, and goal-based savings— all in one seamless and
                            powerful app
                            experience.</p>
                    </div> -->
          <div class=" login-box">
            <h2>Reset Password</h2>
            <!-- <button class="google-btn"><img src="./images/google.png" width="18" alt="G" />Continue with Google</button>
            <div class="divider">or</div> -->
            <form>

              <!-- <div class="form-group">
                <label for="old-password">Old Password</label>
                <input type="password" id="old-password" placeholder="Enter old password" formControlName="oldPassword"
                  required>
              </div> -->

              <div class="form-group">
                <label for="new-password">New Password</label>
                <input type="password" id="new-password" name="newPassword" [(ngModel)]="newPassword" #newPass="ngModel"
                  placeholder="Enter new password" required minlength="6" />
                <!-- Built-in validation messages -->
                <div *ngIf="newPass.invalid && newPass.touched" style="color: red;">
                  <div *ngIf="newPass.errors?.['required']">New Password is required.</div>
                  <div *ngIf="newPass.errors?.['minlength']">Password must be at least 6 characters.</div>
                </div>
              </div>

              <!-- Confirm Password -->
              <div class="form-group">
                <label for="confirm-password">Confirm Password</label>
                <input type="password" id="confirm-password" name="confirmPassword" [(ngModel)]="confirmPassword"
                  #confirmPass="ngModel" placeholder="Confirm new password" required />
                <!-- Custom error message for mismatch -->
                <div *ngIf="confirmPass.touched && confirmPassword !== newPassword" style="color: red;">
                  Passwords do not match.
                </div>
                <!-- Required message -->
                <div *ngIf="confirmPass.touched && confirmPass.errors?.['required']" style="color:red;">
                  Confirm Password is required.
                </div>
              </div>

              <button class="login-btn" [disabled]="!newPassword || !confirmPassword" (click)="updatePassword()">Update
                Password</button>
            </form>


            <div class="bottom-text">
              have an account? <br> <a (click)="redirectToSignUp()">login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>